<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.generalConsultations', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
<!--                <div class="card-title">-->
<!--                    <router-link :to="{ name: 'add-consultation-general' }" v-if="can">-->
<!--                        {{ $t('message.add') }}-->

<!--                        <i class="fas fa-plus-circle edit-icon"></i>-->
<!--                    </router-link>-->
<!--                </div>-->

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mConsultations"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>

                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="generals-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mConsultations"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data" >
                            <div class="row" v-if="data.item.isAuthor || hasAdminRole">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-consultation-general', params: { consultation: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.generalConsultations', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.user }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteConsultation(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                            <b-pagination
                                    class="justify-content-center"
                                    v-model="currentPage"
                                    :total-rows="rows"
                                    :per-page="perPage"
                                    aria-controls="generals-table"
                            ></b-pagination>


                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "GeneralMedicines",

        computed: {
            ...mapGetters(["generalConsultations",'hasAdminRole',
                'hasMedecinControleRole',
                'hasPraticienRole',]),


            mConsultations: function() {
                let cArray = [];

                _.forEach(this.generalConsultations, function(consultation) {
                    let c = {};

                    let user = consultation.dossier.patient.user;

                    c.user =  (user.prenom != null ? user.prenom : '  ') + (user.nom).toUpperCase() + ' ( ' +consultation.dossier.numero_dossier + ' )';
                    c.date_consultation = moment(consultation.date_consultation).format('YYYY/MM/DD');
                    c.anamnese = consultation.anamese;
                    c.mode_de_vie = consultation.mode_de_vie;
                    c.date = moment(consultation.created_at).format('YYYY/MM/DD HH:mm');
                    c.id = consultation.id;
                    c.slug = consultation.slug;
                    c.isAuthor = consultation.isAuthor;

                    cArray.push(c);
                });

                return cArray;
            },

            rows: function() {
                return this.mConsultations.length;
            },
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole;
                }
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                sortBy: 'date',
                sortDesc: true,
                fields: [
                    {
                        key: 'user',
                        label: this.$i18n.tc('message.patients', 1),
                    },
                    {
                        key: 'date_consultation',
                        label: this.$i18n.t('message.consultationDate'),
                        sortable: true
                    },
                    {
                        key: 'anamnese',
                        label: this.$i18n.t('message.anamnesis'),
                    },
                    {
                        key: 'mode_de_vie',
                        label: this.$i18n.t('message.lifestyle'),
                    },
                    {
                        key: 'date',
                        label: this.$i18n.t('message.createdAt'),
                        sortable: true
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getConsultations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getGeneralConsultations', { args : args });
            },

            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                this.$router.push({ name: 'consultation-general', params: { consultation: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'consultation-general', params: { consultation: items[0].slug } });
            },

            deleteConsultation(consultation) {
                let self = this;

                let args = {
                    consultation: consultation
                };

                let successMessage = this.$i18n.t('message.generalConsultationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteGeneralConsultation', { args, index: consultation, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + consultation);
                    });
            }
        },

        mounted() {
            // Fetch general consultation list
            this.getConsultations();
        }
    }
</script>

<style scoped>

</style>